class CustomerService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getCustomers(params) {
    return this.apiService.get('/api/v1/one/customer', params);
  }

  createCustomer(params) {
    return this.apiService.post('/api/v1/one/customer', params);
  }

  updateCustomer(params) {
    return this.apiService.put(`/api/v1/one/customer/${params.id}`, params);
  }

  deleteCustomers(params) {
    return this.apiService.delete('/api/v1/one/customer', params);
  }
}

export default CustomerService;
